var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "staff-page" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "dislog-box",
          attrs: {
            visible: _vm.visible,
            top: "0vh",
            width: "512px",
            center: "",
            "show-close": false
          },
          on: { close: _vm.onClose }
        },
        [
          _c("div", { staticClass: "dislog-content" }, [
            _c("div", { staticClass: "staff-info-box" }, [
              _c(
                "div",
                { staticClass: "scroll-box" },
                _vm._l(_vm.staffs, function(item) {
                  return _c(
                    "div",
                    { key: item.seniority, staticClass: "group-box" },
                    [
                      _c("div", { staticClass: "tit-box" }, [
                        _c("div", { staticClass: "divider" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "seniority" }, [
                          _vm._v(_vm._s(item.seniority) + " 年员工")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "divider end" })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "list-box" },
                        _vm._l(item.group, function(it) {
                          return _c(
                            "div",
                            { key: it.id, staticClass: "item-box" },
                            [
                              _c("div", { staticClass: "avatar" }, [
                                +it.status && it.file
                                  ? _c("img", {
                                      attrs: {
                                        src: it.file,
                                        width: "100%",
                                        height: "100%"
                                      }
                                    })
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "intro" }, [
                                _c("span", { staticClass: "nickname" }, [
                                  _vm._v(_vm._s(it.nickName))
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "divider" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "name" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("staffDepartment")(it.department)
                                    )
                                  )
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2825822a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2825822a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/staffDialog/index.vue
// module id = null
// module chunks = 